/**
 * Actions
 */
import { createActions } from 'redux-actions';

import ActionFactory from './ActionFactory';
import {
  FILE,
  FETCH_FILE_LIST,
  FETCH_FILE_URL,
  DELETE_FILE,
  GET_PHOTO_DOWNLOAD_URL,
} from '../constants/ActionTypes';
import FileAPIConnectors from '../api/FileAPIConnectors';

const plainActions = createActions(
  ...Object.values(ActionFactory(FETCH_FILE_LIST)),
  ...Object.values(ActionFactory(FETCH_FILE_URL)),
  ...Object.values(ActionFactory(DELETE_FILE)),
  ...Object.values(ActionFactory(GET_PHOTO_DOWNLOAD_URL)),
  { prefix: FILE },
);

const thunkActions = {
  fetchFileList: assessmentId => (
    async (dispatch) => {
      try {
        dispatch(plainActions.fetchFileListRequest());
        const result = await FileAPIConnectors.getFileList(assessmentId);
        dispatch(plainActions.fetchFileListSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.fetchFileListFailure(err));
        return err;
      }
    }
  ),
  fetchFileURL: params => (
    async (dispatch) => {
      try {
        dispatch(plainActions.fetchFileURLRequest());
        const result = await FileAPIConnectors.getDownloadURL(params);
        dispatch(plainActions.fetchFileURLSuccess());
        return result;
      } catch (err) {
        dispatch(plainActions.fetchFileURLFailure(err));
        return err;
      }
    }
  ),
  deleteFile: params => (
    async (dispatch) => {
      try {
        dispatch(plainActions.deleteFileRequest());
        await FileAPIConnectors.deleteFile(params);
        dispatch(plainActions.deleteFileSuccess());
        return true;
      } catch (err) {
        dispatch(plainActions.deleteFileFailure(err));
        return err;
      }
    }
  ),
  getPhotoDownloadURL: url => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getPhotoDownloadURLRequest());
        const result = await FileAPIConnectors.getPhotoDownloadURL(url);
        if (/https?:\/\//i.test(result)) {
          dispatch(plainActions.getPhotoDownloadURLSuccess(result));
          return result;
        }
        throw new Error('Wrong URL format!');
      } catch (err) {
        dispatch(plainActions.getPhotoDownloadURLFailure(err));
        return err;
      }
    }
  ),
};

export default {
  ...plainActions,
  ...thunkActions,
};



// WEBPACK FOOTER //
// ./src/actions/FileActionCreators.js